__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@rshbintech.dboul/swift-messages-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.9.0", () => (Promise.all([__webpack_require__.e(6352), __webpack_require__.e(8063)]).then(() => (() => (__webpack_require__(48063))))));
			register("@reduxjs/toolkit", "1.9.3", () => (Promise.all([__webpack_require__.e(6352), __webpack_require__.e(7281)]).then(() => (() => (__webpack_require__(97281))))));
			register("@rshbintech.dboul/access-control", "1.8.0", () => (Promise.all([__webpack_require__.e(8416), __webpack_require__.e(1926)]).then(() => (() => (__webpack_require__(50379))))));
			register("@rshbintech.dboul/analytics", "1.6.3", () => (__webpack_require__.e(4915).then(() => (() => (__webpack_require__(54915))))));
			register("@rshbintech.dboul/analytics", "1.6.4", () => (__webpack_require__.e(8042).then(() => (() => (__webpack_require__(18042))))));
			register("@rshbintech.dboul/analytics", "1.6.4", () => (__webpack_require__.e(1713).then(() => (() => (__webpack_require__(81713))))));
			register("@rshbintech.dboul/core-ui", "1.87.1", () => (Promise.all([__webpack_require__.e(4984), __webpack_require__.e(8416), __webpack_require__.e(1051), __webpack_require__.e(6957), __webpack_require__.e(7557)]).then(() => (() => (__webpack_require__(34984))))));
			register("@rshbintech.dboul/http", "1.881.0", () => (Promise.all([__webpack_require__.e(2021), __webpack_require__.e(7032), __webpack_require__.e(6537)]).then(() => (() => (__webpack_require__(72021))))));
			register("@rshbintech.dboul/http", "1.891.0", () => (Promise.all([__webpack_require__.e(8927), __webpack_require__.e(7032), __webpack_require__.e(4147)]).then(() => (() => (__webpack_require__(58927))))));
			register("@rshbintech.dboul/http", "1.891.0", () => (Promise.all([__webpack_require__.e(3643), __webpack_require__.e(7032), __webpack_require__.e(8037)]).then(() => (() => (__webpack_require__(23643))))));
			register("@rshbintech.dboul/icons", "1.41.0", () => (Promise.all([__webpack_require__.e(4782), __webpack_require__.e(8416), __webpack_require__.e(5734)]).then(() => (() => (__webpack_require__(54782))))));
			register("@rshbintech.dboul/images", "1.99.0", () => (Promise.all([__webpack_require__.e(5176), __webpack_require__.e(8416), __webpack_require__.e(8479)]).then(() => (() => (__webpack_require__(66748))))));
			register("@rshbintech.dboul/logger", "1.3.1", () => (Promise.all([__webpack_require__.e(9041), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(69041))))));
			register("@rshbintech.dboul/shared-context", "1.2.0", () => (Promise.all([__webpack_require__.e(8416), __webpack_require__.e(8322)]).then(() => (() => (__webpack_require__(68322))))));
			register("@rshbintech.dboul/shared-ui", "1.210.0", () => (Promise.all([__webpack_require__.e(5980), __webpack_require__.e(8416), __webpack_require__.e(7032), __webpack_require__.e(1051), __webpack_require__.e(6957), __webpack_require__.e(7827), __webpack_require__.e(4147), __webpack_require__.e(9235), __webpack_require__.e(1556)]).then(() => (() => (__webpack_require__(55976))))));
			register("@rshbintech.dboul/utils", "1.20.0", () => (Promise.all([__webpack_require__.e(8214), __webpack_require__.e(8894), __webpack_require__.e(8416), __webpack_require__.e(7032), __webpack_require__.e(1720), __webpack_require__.e(6421)]).then(() => (() => (__webpack_require__(58894))))));
			register("@rshbintech.dboul/utils", "1.22.0", () => (Promise.all([__webpack_require__.e(8214), __webpack_require__.e(8367), __webpack_require__.e(8416), __webpack_require__.e(7032), __webpack_require__.e(6122), __webpack_require__.e(3376)]).then(() => (() => (__webpack_require__(68367))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(4403).then(() => (() => (__webpack_require__(64403))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(3961), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(73961))))));
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(83), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(30083))))));
			register("react-router-dom", "6.8.2", () => (Promise.all([__webpack_require__.e(9460), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(89460))))));
			register("react", "18.2.0", () => (__webpack_require__.e(9526).then(() => (() => (__webpack_require__(89526))))));
			initExternal(59781);
			initExternal(67761);
			initExternal(35900);
			initExternal(65125);
			initExternal(85153);
			initExternal(26080);
			initExternal(14988);
			initExternal(9467);
			initExternal(52800);
			initExternal(82660);
			initExternal(79006);
			initExternal(16525);
			initExternal(90810);
			initExternal(66818);
			initExternal(98290);
			initExternal(35980);
			initExternal(96210);
			initExternal(19821);
			initExternal(22428);
			initExternal(24863);
			initExternal(76417);
			initExternal(34190);
			initExternal(77117);
			initExternal(18607);
			initExternal(13453);
			initExternal(96999);
			initExternal(83033);
			initExternal(90466);
			initExternal(75792);
			initExternal(20789);
			initExternal(31542);
			initExternal(75538);
			initExternal(79534);
			initExternal(4680);
			initExternal(76035);
			initExternal(77910);
			initExternal(97791);
			initExternal(81289);
			initExternal(85164);
			initExternal(16534);
			initExternal(97075);
			initExternal(30);
			initExternal(47979);
			initExternal(13517);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};